import * as React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

export default function ScrollDialog({
  show,
  children,
  title,
  submitButtonLable,
  onClose,
  onSubmit,
  headerStyle
}) {
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState("paper");

  const handleClickOpen = (scrollType) => () => {
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (show) {
      handleClickOpen("paper");
    }
    setOpen(show);
  }, [show]);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      
      >
        {title ? (
          <DialogTitle id="scroll-dialog-title" style={headerStyle}>
            {title}
          </DialogTitle>
        ) : null}

        <DialogContent dividers={scroll === "paper"}>{children}</DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={onSubmit}>{submitButtonLable}</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
